import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBrandMt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={200}
    height={200}
    className="brand_mt_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}>
    <path
      fill="#FFC300"
      d="M203.072 0h617.856C956.288 0 1024 67.68 1024 203.072v617.856C1024 956.288 956.32 1024 820.928 1024H203.072C67.712 1024 0 956.32 0 820.928V203.072C0 67.712 67.68 0 203.072 0"
    />
    <path d="M431.2 322.56h-41.184C382.528 344.736 380 353.632 380 353.632H219.68s-2.4-8.896-10.016-31.072h-41.088v31.072h-49.12v37.152h156.928v30.688H127.168v39.968h149.216v28.256H127.168v39.968h149.216v28.864H119.456v39.36H261.76s-40.096 51.36-144 56.064v41.952s112.832 10.88 182.08-79.232c0 0 47.2 77.632 180.384 79.36v-43.584s-89.408 2.688-141.216-54.656h141.216v-39.36H324.48v-28.768h148.224v-39.968H324.48V461.44h148.224v-40H324.48v-30.656h155.744v-37.152h-49.12zM622.72 625.6h47.904a502.8 502.8 0 0 0 50.88-160.672H763.2V565.92a401 401 0 0 1-6.72 59.968h44.224a373 373 0 0 0 5.12-59.968V464.96h28.736v-39.04h-28.672V393.6h-42.56v32.576H609.184v38.944h67.36a426.4 426.4 0 0 1-53.824 160.448z" />
    <path d="M542.72 332.8v368.64h310.944a52.736 52.736 0 0 0 52.576-52.8V332.8zm323.008 315.84a12.8 12.8 0 0 1-12.768 12.864H582.848V372.32h282.88z" />
  </svg>
);
export default SvgBrandMt;
